import { PhoneTypes } from 'generated/graphql-types';
import { GetExtensions_extensionsConnection_items } from '../../extension-register/queries/generated/GetExtensions';

export interface PhoneTypeConnectionStatus {
   phoneType: PhoneTypes;
   sipUserCount: number;
   connectedCount: number;
}

// Fixed left-to-right order so icon positions stay stable from row to row.
const phoneTypeDisplayOrder: PhoneTypes[] = [
   PhoneTypes.Hardphone,
   PhoneTypes.Softphone,
   PhoneTypes.Appsuite,
   PhoneTypes.Handset,
];

export function getLastProvisionedDate(getExtensionItem: GetExtensions_extensionsConnection_items): Date | null {
   const hardPhones = getExtensionItem.phonesConnection.items.filter((p) => p.phoneType === PhoneTypes.Hardphone);
   const provisionedPhones = hardPhones.map((p) =>
      p.devicesConnection.items.filter((d) => d.lastProvisionedDate != null).map((i) => i.lastProvisionedDate)
   );

   const provisionedDates: Date[] = Array.prototype.concat.apply([], provisionedPhones);
   return provisionedDates.sort()[provisionedDates.length - 1] ?? null;
}

export function getPhoneTypeStatuses(
   getExtensionItem: GetExtensions_extensionsConnection_items
): PhoneTypeConnectionStatus[] {
   const statusesByPhoneType = new Map<PhoneTypes, PhoneTypeConnectionStatus>();

   for (const phone of getExtensionItem.phonesConnection?.items ?? []) {
      const sipUsers = phone.sipUsersConnection?.items ?? [];

      if (sipUsers.length === 0) {
         continue;
      }

      const status = statusesByPhoneType.get(phone.phoneType) ?? {
         phoneType: phone.phoneType,
         sipUserCount: 0,
         connectedCount: 0,
      };

      status.sipUserCount += sipUsers.length;
      status.connectedCount += sipUsers.filter((sipUser) => sipUser.isConnected).length;
      statusesByPhoneType.set(phone.phoneType, status);
   }

   return phoneTypeDisplayOrder
      .map((phoneType) => statusesByPhoneType.get(phoneType))
      .filter((status): status is PhoneTypeConnectionStatus => status != null);
}
